import React, {Component} from "react";
import AboutComponent from "../components/AboutComponent";

export class About extends Component{
    render(){
        return(
            <AboutComponent />
        )
    }
}

export default About;